/*
 *
 * memoryAPI.js
 *
 */

import Axios from "axios";

const memoryAPI = {
  fetchAll: async () => await Axios.get(`${window.API_URL}/memory/get.php`),
  assignToTitle: async (data) =>
    await Axios.post(`${window.API_URL}/memory/assign.php`, {
      titleID: data.titleID,
      memoryID: data.memoryID,
    }),
  assignToProject: async (data) =>
    await Axios.post(`${window.API_URL}/memory/assign.php`, {
      projectID: data.projectID,
      memoryID: data.memoryID,
    }),
  fetchByID: async (data) =>
    await Axios.get(
      `${window.API_URL}/memory/get.php?memoryID=${data.memoryID}`
    ),
  fetchByTitle: async (data) =>
    await Axios.get(`${window.API_URL}/memory/get.php?titleID=${data.titleID}`),
  fetchByProject: async (data) =>
    await Axios.get(
      `${window.API_URL}/memory/get.php?projectID=${data.projectID}`
    ),
  fetchByTask: async (data) =>
    await Axios.get(`${window.API_URL}/memory/get.php?taskID=${data.taskID}`),
  create: async (data) => {
    let formData = new FormData();
    formData.append("name", data.name);
    formData.append("sourceLang", data.sourceLang);
    formData.append("sourceColumn", data.sourceColumn);
    formData.append("note", data.note);
    formData.append("targets", JSON.stringify(data.targets ?? []));
    formData.append("rowCount", data.rowCount);
    formData.append("file", data.file);

    return await Axios.post(
      `${window.API_URL}/memory/createNew.php`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        } /*,
            
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                if (data.setProgress) data.setProgress(percentCompleted); // Update progress
                
            }*/,
      }
    );
  },

  updatePenaltiesByProject: async (data) =>
    await Axios.post(`${window.API_URL}/memory/updatePenalty.php`, {
      penalty: data.penalty,
      memoryIDs: data.memoryIDs,
      projectID: data.projectID,
    }),
  updatePenaltiesByTitle: async (data) =>
    await Axios.post(`${window.API_URL}/memory/updatePenalty.php`, {
      penalty: data.penalty,
      memoryIDs: data.memoryIDs,
      titleID: data.titleID,
    }),
  setWritesByProject: async (data) =>
    await Axios.post(`${window.API_URL}/memory/setWrite.php`, {
      write: data.write,
      memoryIDs: data.memoryIDs,
      projectID: data.projectID,
    }),
  setWritesByTitle: async (data) =>
    await Axios.post(`${window.API_URL}/memory/setWrite.php`, {
      write: data.write,
      memoryIDs: data.memoryIDs,
      titleID: data.titleID,
    }),
  unassignFromTitle: async (data) =>
    await Axios.post(`${window.API_URL}/memory/unassign.php`, {
      titleID: data.titleID,
      memoryIDs: data.memoryIDs,
    }),
  unassignFromProject: async (data) =>
    await Axios.post(`${window.API_URL}/memory/unassign.php`, {
      projectID: data.projectID,
      memoryIDs: data.memoryIDs,
    }),
  saveModifications: async (data) =>
    await Axios.post(`${window.API_URL}/memory/saveModifications.php`, {
      id: data.id,
      source: data.source,
      target: data.target,
    }),
  setName: async (data) =>
    await Axios.post(`${window.API_URL}/memory/setName.php`, {
      memoryID: data.memoryID,
      memoryName: data.memoryName,
    }),
  delete: async (data) =>
    await Axios.post(`${window.API_URL}/memory/delete.php`, {
      memoryID: data.memoryID,
    }),
  import: async (data) => {
    let formData = new FormData();
    formData.append("memoryID", data.memoryID);
    formData.append("sourceCol", data.sourceColumn);
    formData.append("targets", JSON.stringify(data.targets));
    formData.append("file", data.file);
    formData.append("rowCount", data.rowCount);

    return await Axios.post(
      `${window.API_URL}/memory/importNew.php`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },

        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          if (data.setProgress) data.setProgress(percentCompleted); // Update progress
        },
      }
    );
  },
};

export default memoryAPI;
